import { Divider } from "@mui/material";
import { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import { CreateCarUserTokenEntity } from "../../../../../entities/ServicesEntities/UserEntities/CreateCarUserTokenEntity";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import * as carUserTokenActionsService from "../../../../../services/ActionsService/CarUserTokenActionsService";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { getProgressBarValue } from "../../../../../utils/CommonUtils";
import { arrayNotEmpty } from "../../../../../utils/FormUtils";
import { handleDeleteOccupiedToken } from "../../../../../utils/MenuUtils";
import { showErrorMessage, showUpdateSuccessMessage } from "../../../../../utils/MessagesUtils";
import SummaryAssignedAllocations from "../../../Accordion/SummaryAssignedAllocations/SummaryAssignedAllocations";
import classes from "../WizardForm.module.css";
import AddSingleTokenWithFob from "./Sub-Steps/AddSingleTokenWithFob";
import { isRequired } from "../../../../../utils/FormUtils";

const AddTokensWithFobStep = forwardRef((props, ref) => {
  const [errors, setErrors] = useState({});
  const [hasStepErrors, setHasStepErrors] = useState(false);
  const [showSummaryStep, setShowSummaryStep] = useState(props?.isEditMode);
  const [occupiedTokens, setOccupiedTokens] = useState(
    props?.isEditMode ? props?.carUserTokens : []
  );

  // const selectedSite = useSelector((state) =>
  //   state.user.sites.find((site) => site.id === props.site)
  // );

  let selectedSite = props.selectedSite;
  const isShowStep = props?.currentStep <= props?.totalSteps;

  // added
  const AddSingleTokenWithFobRef = useRef();

  // added
  useImperativeHandle(ref, () => ({
    AddSingleTokenWithFobRef,
    occupiedTokens,
    setOccupiedTokens
  }));

  useEffect(() => {
    setOccupiedTokens(props?.isEditMode ? props?.carUserTokens : []);
  }, [props.site]);

  useEffect(() => {
    if (
      props.currentStep === ADD_PARKER_FORM_STEPS.ADD_TOKENS &&
      selectedSite?.isFobsSupported
    ) {
      const hasError = Object.values(errors).some((error) => !error.isValid);
      setHasStepErrors(hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [occupiedTokens, errors]);

  useEffect(() => {
    setHasStepErrors(false);
    validateStep();
  }, [occupiedTokens, props.currentStep]);

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.ADD_TOKENS) {
      const stepHeader = new StepHeaderEntity(
        props.isEditMode
          ? Strings.STEPS_TITLES.ADD_TOKEN_MODAL_TITLE
          : Strings.STEPS_TITLES.ADD_TOKEN_MODAL_TITLE,
        props.isEditMode
          ? ""
          : isShowStep ? Strings.STEPS_TITLES.ADD_TOKEN_MODAL_SUB_TITLE : "",
        Icons.CAR2,
        props.isEditMode
          ? null
          : isShowStep ? getProgressBarValue(ADD_PARKER_FORM_STEPS.ADD_TOKENS) : null
      );
      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
    }
  }, [props]);

  const validateStep = () => {
    let validateTokens = arrayNotEmpty(occupiedTokens);//props.isStepSubmitted
    validateTokens.isValid = props.isStepSubmitted ? validateTokens.isValid : true;
    setErrors({
      ...errors,
      tokens: validateTokens,
    });
  };

  if (
    props.currentStep !== ADD_PARKER_FORM_STEPS.ADD_TOKENS ||
    (!selectedSite?.isFobsSupported && !props.isFobSkipped) // added && !isFobSkipped
  ) {
    return null;
  }

  const handleAssignTokenToFob = (token, skipFob = false) => {
    let occupiedTokenCopy = [...occupiedTokens];
    const assignedToken = { fob: props.fob === '' || skipFob ? null : props.fob, occupiedToken: token }; // fob: props.fob
    occupiedTokenCopy.push(assignedToken);
    setOccupiedTokens(occupiedTokenCopy);

    //update form
    props.handleChange({
      [INPUTS_PROPS.TOKENS]: occupiedTokenCopy.map(
        (token) => token?.occupiedToken
      ),
      [INPUTS_PROPS.CAR_USER_TOKEN]: occupiedTokenCopy.map((token) => {
        let carToken = new CreateCarUserTokenEntity();
        const obj = {
          // if car data is already populated (user filled car data and moved with steps back), 
          // use existing car data
          car: props.cars?.length > 0 ? props.cars?.[0] : null,
          token: token?.occupiedToken,
          fob: props.fob === '' || skipFob ? null : props.fob, // // fob: props.fob
        };
        return { ...carToken, ...obj };
      }),
      // [INPUTS_PROPS.FOB]: "",  // [INPUTS_PROPS.FOB]: ""
    });

    setShowSummaryStep(true);
  };

  // added - clearAllTokens
  const handleClearAllTokens = () => {
    setOccupiedTokens([]);
  };

  const handleDeleteTokenByIndex = (index) => {
    // added
    if (props.isFobSkipped) {
      props.handleChange({ ["carUserTokens"]: [] });
      store.dispatch(commonActions.setAssigneOption(null));
    }
    if (index > -1) {
      const token = occupiedTokens[index].occupiedToken;
      const userTokens = props.carUserTokens.map(
        (token) => token.occupiedToken
      );
      const userTokensIds = userTokens?.map((ot) => ot?.id);
      if (props.isEditMode && userTokensIds.includes(token?.id)) {
        const exsistOccupiedToken = occupiedTokens[
          index
        ].occupiedToken.carUserTokens?.find(
          (cut) => cut.userId === props?.userData?.id
        );
        if (exsistOccupiedToken) {
          handleDeleteOccupiedToken(
            props.userData,
            token?.displayValue,
            deleteCarUsertokenFromServer.bind(
              this,
              exsistOccupiedToken?.id,
              index
            )
          );
        }
      } else {
        deleteCarUsertokenFromView(index);
        if (props.fromGmt === undefined) {
          props.setIsShowSaveChanges(false);
        }
      }
    }
  };
  const deleteCarUsertokenFromView = (index) => {
    let occupiedTokenCopy = [...occupiedTokens];
    occupiedTokenCopy.splice(index, 1);
    setOccupiedTokens(occupiedTokenCopy);
  };

  const deleteCarUsertokenFromServer = (carUserTokenId, index) => {
    carUserTokenActionsService
      .deleteCarUserToken(carUserTokenId)
      .then((response) => {
        if (response.data.isSuccess) {
          showUpdateSuccessMessage();
          deleteCarUsertokenFromView(index);
        } else {
          showErrorMessage(response.data?.error);
        }
      });
  };

  const setShowStepError = (boolean) => {
    setHasStepErrors(boolean);
  }
  
  const handleChange = (event) => {
    if(event[INPUTS_PROPS.FOB]){
      setErrors({...errors, [INPUTS_PROPS.FOB]: isRequired(event[INPUTS_PROPS.FOB])});
    }
    props.handleChange(event);
  }

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.ADD_TOKEN_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.ADD_TOKEN_SUB_TITLE}
      </span>
      <div className={classes.addFobStepContainer}>
        <AddSingleTokenWithFob
          {...props}
          setShowSummaryStep={setShowSummaryStep}
          selectedSite={selectedSite}
          handleAssignTokenToFob={handleAssignTokenToFob}
          setShowStepError={setShowStepError} // added
          setIsCurrentStepValid={props.setIsCurrentStepValid} // added
          isFobSkipped={props.isFobSkipped}
          dialingCode={props.dialingCode}
          setIsFobSkipped={props.setIsFobSkipped}
          // ref={AddSingleTokenWithFobRef} // added
          handleClearAllTokens={handleClearAllTokens}
          setIsAddParkingAllocationInProcess={props.setIsAddParkingAllocationInProcess}
          setIsShowSaveChanges={props.setIsShowSaveChanges}
          occupiedTokens={occupiedTokens}
          totalSteps={props.totalSteps}
          handleChange={handleChange}
        />
        {/* Summary */}
        {showSummaryStep && occupiedTokens.length > 0 && (
          <div className={classes.summaryAllocationStep}>
            <Divider />
            <span className={classes.stepSubTitle}>
              {Strings.ASSIGNED_PARKING_ALLOCATIONS}
            </span>
            {occupiedTokens.map((token, index) => {
              return (
                <SummaryAssignedAllocations
                  isShowClearIcon={props.isEditMode !== undefined ? true : false}
                  key={index}
                  {...token}
                  index={index + 1}
                  handleDeleteTokenByIndex={handleDeleteTokenByIndex}
                  selectedSite={selectedSite}
                />
              );
            })}
          </div>
        )}
      </div>
      {
        props.isStepSubmitted && hasStepErrors&&  (
          <div className={classes.error}>This step is required</div>
        )
      }
    </div >
  );
}); // added ) - for forward ref

export default AddTokensWithFobStep;
